import React, { useState } from "react"
import { PageProps } from "gatsby"
import { useIntl } from "gatsby-plugin-intl"
import classNames from "classnames"

import styles from "./blog.module.scss"
import Layout from "../../components/Layout/Layout"
import SEO from "../../components/seo"
import { useBlogPosts } from "../../hooks"
import BlogPostCard from "../../components/BlogCard/BlogPostCard"

const types = [
	{
		name: "all",
		translatePath: "blog.post-types.all",
	},
	{
		name: "news",
		translatePath: "blog.post-types.news",
	},
	{
		name: "articles",
		translatePath: "blog.post-types.articles",
	},
]

const Blog: React.FC<PageProps> = ({ location }) => {
	const intl = useIntl()
	const blogPosts = useBlogPosts(intl.locale)

	const [currentType, currentTypeSetter] = useState("all")


	const postTypeModeChange = event => {
		if (event && event.target && event.target.id) {
			currentTypeSetter(event.target.id)
		}
	}


	return (
		<Layout location={location}>
			<SEO
				language={intl.locale}
				description={intl.formatMessage({ id: "blog.seo.description" })}
				title={intl.formatMessage({ id: "blog.seo.title" })}
				pathname={location.pathname}
			/>
			<div className={styles.container}>
				<h1 className={styles.title}>
					{intl.formatMessage({ id: "blog.title" })}
				</h1>
				<fieldset className={styles.postTypeGroup}>
					<legend className={styles.postTypeLegend}>
						Post type selector
					</legend>

					{types.map(({ name, translatePath }) => (
						<div className={styles.postTypeBlock} key={name}>
							<input
								className={styles.postTypeInput}
								type="radio"
								id={name}
								name="post-type"
								checked={name === currentType}
								onChange={postTypeModeChange}
							/>
							<label className={styles.postTypeLabel} htmlFor={name}>
								{intl.formatMessage({ id: translatePath })}
							</label>
						</div>
					))}
				</fieldset>

				<ul className={styles.list}>
					{blogPosts.edges
						.filter(({ node }) => {
							const { posttype } = node.frontmatter
							switch (currentType) {
								case "all":
									return true
								default:
									return posttype === currentType
							}
						})
						.filter(
							(post, index) => index < 30
						)
						.map(({ node }) => {
							const {
								date,
								title,
								externalLink,
								thumbnail,
							} = node.frontmatter
							const { slug } = node.fields
							return (
								<li className={styles.item} key={slug}>
									<BlogPostCard
										date={date}
										title={title}
										externalLink={externalLink}
										slug={slug}
										thumbnail={thumbnail}
									/>
								</li>
							)
						})}
				</ul>
			</div>
		</Layout>
	)
}

export default Blog
